import React from 'react';

export interface PublicIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const PublicIcon: React.FC<PublicIconProps> = ({
  width = 24,
  height = 24,
  color = '#6DA6B9',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-label='Public'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.5 9.58594V12.6182L13.7363 13.5H11V16H9V8H13.9141L15.5 9.58594ZM11 11.5H13.2637L13.5 11.3818V10.4141L13.0859 10H11V11.5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 7V17L12 22L3 17V7L12 2L21 7ZM5 8.17676V15.8232L12 19.7119L19 15.8232V8.17676L12 4.28711L5 8.17676Z'
        fill={color}
      />
    </svg>
  );
};
